import React, { useState } from 'react';
import { HiOutlineBriefcase, HiOutlineClock, HiOutlineCurrencyRupee, HiOutlineLocationMarker } from 'react-icons/hi';
import { PositionChip } from 'src/components/placementDrives/shared';
import { UIExtendedApplication } from 'types';
interface Props {
	application: UIExtendedApplication;
}
const PositionDetails = ({ application }: Props) => {
	const [showRecommendationInfo, setShowRecommendationInfo] = useState(false);
	const minSalary = application.position?.salary.min;
	const maxSalary = application.position?.salary.max;
	const location = application.position?.workLocations;
	const locationArray = Array.isArray(location) ? location : location ? [location] : [];
	const workLocation = application.position?.workLocation;
	if (workLocation && !locationArray.includes(workLocation)) {
		locationArray.push(workLocation);
	}
	const locationString = locationArray.join(' | ');
	const type = application.position?.positionType;
	const workingMode = application.position?.workingMode;
	const showInterestedProfileNote = (application as any)?.recommendationTypes?.includes('you_might_be_interested');
	const workingExp = application.position?.positionRequirement.workExperience
		? application.position?.positionRequirement.workExperience.min === 0 &&
			application.position?.positionRequirement.workExperience.max === 0
			? 'Fresher'
			: `${Math.floor(application.position?.positionRequirement.workExperience.min)} Yrs ${Math.ceil(application.position?.positionRequirement.workExperience?.min * 12) % 12
			} Mon - ${Math.floor(application.position?.positionRequirement.workExperience.max)} Yrs ${Math.ceil(application.position?.positionRequirement.workExperience?.max * 12) % 12
			} Mon `
		: '';
	return (
		<div className="mt-4">
			<div className="flex flex-wrap gap-2">
				<PositionChip
					icon={HiOutlineBriefcase}
					text={workingMode === 'FullTime' ? 'Full-time' : workingMode === 'InternshipToFullTime' ? 'Internship + Full-time' : String(workingMode || '')}
				/>
				{workingExp ? <PositionChip icon={HiOutlineClock} text={workingExp.trim()} /> : null}
				<PositionChip icon={HiOutlineCurrencyRupee} text={`${minSalary} - ${maxSalary} LPA`} />
				{locationString || type ? (
					<PositionChip icon={HiOutlineLocationMarker} text={[locationString, type].filter(Boolean).join(' · ')} />
				) : null}
			</div>
			{showInterestedProfileNote ? (
				<div className="mt-3 rounded-2xl border border-[#E0DEFF] bg-[#F6F5FF] px-4 py-3">
					<button
						type="button"
						onClick={event => {
							// Prevent card click handlers from opening the main drawer.
							event.preventDefault();
							event.stopPropagation();
							setShowRecommendationInfo(prev => !prev);
						}}
						className="flex w-full items-center justify-between text-left"
					>
						<span className="text-[13px] font-semibold text-[#3730A3]">Why this role?</span>
						<span className="rounded-full bg-[#4338CA] px-2 py-[2px] text-[10px] font-semibold uppercase tracking-wide text-white">
							{showRecommendationInfo ? 'Hide' : 'Tap to read'}
						</span>
					</button>
					<div
						className={`overflow-hidden transition-all duration-300 ease-in-out ${showRecommendationInfo ? 'max-h-40 opacity-100 mt-2' : 'max-h-0 opacity-0'
							}`}
					>
						<p className="text-[13px] leading-[20px] text-[#312E81]">
							We are recommending this role based on your prior experience and skill set. If you feel these opportunities
							do not align with what you studied at Masai School, you may choose to ignore these recommendations.
						</p>
					</div>
				</div>
			) : null}
		</div>
	);
};

export default PositionDetails;
